import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class GlobalLoaderService {

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  loadExternalScript(scriptUrl) {
    return new Promise(resolve => {
      const scriptElement = this.document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      this.document.body.appendChild(scriptElement);
    });
  }

  loadExternalStyles(styleUrl: string) {
    return new Promise((resolve) => {
      const head = this.document.getElementsByTagName('head')[0];
      const styleElement = this.document.createElement('link');
      styleElement.rel = 'stylesheet';
      styleElement.href = styleUrl;
      head.appendChild(styleElement);
      resolve('');
    });
  }
}
